import { put, select } from "redux-saga/effects";
import { getHubspotTablesFailure, getHubspotTablesSuccess } from "../actionCreators";
import { GetHubspotTablesRequestActionType } from "../types";
import { IntegrationService } from "../integration.service";

export function* getHubspotTablesSaga(action: GetHubspotTablesRequestActionType) {
    try {
        const { table } = action.payload;
        const formId: string = yield select(state => state.forms.current._id);
        const { data } = yield IntegrationService.getHubspotTables(formId, { table });

        if (data?.success) {
            yield put(getHubspotTablesSuccess(data));
        } else {
            yield put(getHubspotTablesFailure(data?.message || "Failed to get hubspot tables config"));
        }
    } catch (error: any) {
        const errorMessage = error.response?.message || "Failed to get hubspot tables";
        console.error("Error getting hubspot tables:", error);
        yield put(getHubspotTablesFailure(errorMessage));
    }
}
